import { Dispatch, SetStateAction } from "react";
import { Alert, Snackbar } from "@mui/material";
import { NotificationProperties } from "@interfaces/Notification";
import { ErrorMessages } from "@constants/errorMessages";

const Notification = ({
    topPadding = 6,
    notification,
    setNotification,
}: {
    topPadding?: number;
    notification: NotificationProperties;
    setNotification: Dispatch<SetStateAction<NotificationProperties>>;
}) => {
    const onClose = () => {
        setNotification({ ...notification, isOpen: false });
    };

    return (
        <>
            {notification.message !== ErrorMessages.APIAbortError && notification.message !== ErrorMessages.APIAbortRequest &&
                <Snackbar
                    open={notification.isOpen}
                    autoHideDuration={notification.autoHideDuration || 5000}
                    onClose={onClose}
                    sx={{ position: "fixed", paddingTop: topPadding }}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    <Alert severity={notification.type} onClose={onClose} sx={{ display: "flex", alignItems: "center" }}>
                        {notification.message}
                    </Alert>
                </Snackbar>
            }
        </>
    );
};

export default Notification;
